<script>
export default {
  props: {
    clr: {
      default: "#768391"
    }
  }
};
</script>
<template>
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0 0.5H1.2H18H19.2V1.7V13.7H22.8H24V14.9V20.9C24 22.8883 22.3883 24.5 20.4 24.5H19.2H3.6C1.61178 24.5 0 22.8883 0 20.9V1.7V0.5ZM19.2 17.3V16.1H21.6V20.9C21.6 21.5628 21.0628 22.1 20.4 22.1C19.7372 22.1 19.2 21.5628 19.2 20.9V18.5V17.3ZM16.8 20.9C16.8 21.3207 16.8722 21.7246 17.0048 22.1H3.6C2.93726 22.1 2.4 21.5628 2.4 20.9V2.9H16.8V13.7V14.9V17.3V18.5V20.9ZM12.0695 9.69223L6.53908 15.2227L4.84202 13.5256L10.3724 7.99516H6.44845V5.59516H13.2695H14.4695V6.79516V13.6162H12.0695V9.69223ZM13.2 17.3H14.4V19.7H13.2H6H4.8V17.3H6H13.2Z"
      :fill="clr"
    />
  </svg>
</template>
